import styled from "styled-components";
import {
    compose,
    display,
    type DisplayProps,
    flexbox,
    type FlexboxProps,
    layout,
    type LayoutProps,
    maxWidth,
    type MaxWidthProps,
    position,
    type PositionProps,
    space,
    type SpaceProps,
    textAlign,
    type TextAlignProps,
} from "styled-system";

const styleProps = compose(space, textAlign, display, maxWidth, flexbox, layout, position);
type StyleType = SpaceProps &
    TextAlignProps &
    DisplayProps &
    MaxWidthProps &
    FlexboxProps &
    LayoutProps &
    PositionProps;

export const Container = styled.div.attrs(() => ({
    className: "container" as string,
}))<StyleType>`
    ${styleProps};
`;

export default Container;
